import * as React from 'react'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import { FaIcon, faXmark } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { ImportedFilesHistorySection } from './ImportedFilesHistorySection'

type Props = {
  companyId: string
  handleClose: () => void
}

const ImportHistoryModal: React.FC<Props> = ({ companyId, handleClose }) => {
  const { t } = useLocalize()

  return (
    <ModalLayout customZIndex={9999}>
      <div className="tw-relative tw-flex tw-h-[90vh] tw-w-full tw-max-w-[90vw] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl">
        <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-p-4">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {t('import.imported-files')}
          </p>
          <FaIcon
            icon={faXmark}
            className="tw-h-5 tw-w-5 tw-cursor-pointer tw-text-content-base hover:tw-text-primary"
            onClick={handleClose}
          />
        </div>
        <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
          <ImportedFilesHistorySection companyId={companyId} />
        </div>
      </div>
    </ModalLayout>
  )
}

export default ImportHistoryModal
